import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../controls/Icon"

const ListStatus = ({
    loading = false,
    loadingText = "OTM_LIST_LOADING",
    error = false,
    errorText = "OTM_LIST_ERROR",
    errorIcon = "ErrorOutline",
    empty = false,
    emptyText = "OTM_LIST_EMPTY",
    emptyIcon = "Block"
}) => {
    const [translate] = useTranslation();

    const listStatus = useMemo(() => {
        const message = loading ? loadingText : (error ? errorText : (empty ? emptyText : ""));
        const icon = loading ? "" : (error ? errorIcon : (empty ? emptyIcon : ""));
        
        if (message) {
            return <div className="d-flex align-items-center">
                { loading ? <div className="spinner-border spinner-border-sm text-dark"></div> : null }
                { icon ? <Icon icon={icon} className="text-dark"></Icon> : null }
                <label className="ms-2 h6 text-dark">{translate(message)}</label>
            </div>;
        }
        else {
            return null;
        }
    }, [loading, loadingText, error, errorText, errorIcon, empty, emptyText, emptyIcon, translate]);

    return <>
        {listStatus}
    </>;
}

export default ListStatus;